module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 20);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _extends2, _extends3, _extends4;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _aphrodite = __webpack_require__(19);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Regular = 400;
var Bold = 700;
var Black = 900;

var mobile = "@media (max-width: 1023px)";
var desktop = "@media (min-width: 1024px)";

var common = {
    display: "block"
};

var LatoFamily = "Lato, sans-serif";
var InconsolataFamily = "Inconsolata, monospace";

var styles = _aphrodite.StyleSheet.create({
    Title: _extends({}, common, (_extends2 = {
        fontFamily: LatoFamily,
        fontWeight: Black
    }, _defineProperty(_extends2, desktop, {
        fontSize: 36,
        lineHeight: "40px"
    }), _defineProperty(_extends2, mobile, {
        fontSize: 28,
        lineHeight: "32px"
    }), _extends2)),
    Tagline: _extends({}, common, {
        fontFamily: LatoFamily,
        fontWeight: Regular,
        fontSize: 20,
        lineHeight: "24px"
    }),
    HeadingLarge: _extends({}, common, (_extends3 = {
        fontFamily: LatoFamily,
        fontWeight: Bold
    }, _defineProperty(_extends3, desktop, {
        fontSize: 28,
        lineHeight: "32px"
    }), _defineProperty(_extends3, mobile, {
        fontSize: 24,
        lineHeight: "28px"
    }), _extends3)),
    HeadingMedium: _extends({}, common, (_extends4 = {
        fontFamily: LatoFamily,
        fontWeight: Bold
    }, _defineProperty(_extends4, desktop, {
        fontSize: 24,
        lineHeight: "28px"
    }), _defineProperty(_extends4, mobile, {
        fontSize: 22,
        lineHeight: "26px"
    }), _extends4)),
    HeadingSmall: _extends({}, common, {
        fontFamily: LatoFamily,
        fontWeight: Bold,
        fontSize: 20,
        lineHeight: "24px"
    }),
    HeadingXSmall: _extends({}, common, {
        fontFamily: LatoFamily,
        fontWeight: Bold,
        fontSize: 12,
        lineHeight: "16px",
        letterSpacing: 0.6,
        textTransform: "uppercase"
    }),
    BodySerifBlock: _extends({}, common, {
        fontFamily: "serif",
        fontWeight: Regular,
        fontSize: 22,
        lineHeight: "28px"
    }),
    BodySerif: _extends({}, common, {
        fontFamily: "serif",
        fontWeight: Regular,
        fontSize: 18,
        lineHeight: "22px"
    }),
    BodyMonospace: _extends({}, common, {
        fontFamily: InconsolataFamily,
        fontWeight: Regular,
        fontSize: 17,
        lineHeight: "22px"
    }),
    Body: _extends({}, common, {
        fontFamily: LatoFamily,
        fontWeight: Regular,
        fontSize: 16,
        lineHeight: "22px"
    }),
    LabelLarge: _extends({}, common, {
        fontFamily: LatoFamily,
        fontWeight: Bold,
        fontSize: 16,
        lineHeight: "20px"
    }),
    LabelMedium: _extends({}, common, {
        fontFamily: LatoFamily,
        fontWeight: Regular,
        fontSize: 16,
        lineHeight: "20px"
    }),
    LabelSmall: _extends({}, common, {
        fontFamily: LatoFamily,
        fontWeight: Regular,
        fontSize: 14,
        lineHeight: "18px"
    }),
    LabelXSmall: _extends({}, common, {
        fontFamily: LatoFamily,
        fontWeight: Regular,
        fontSize: 12,
        lineHeight: "16px"
    }),
    Caption: _extends({}, common, {
        fontFamily: LatoFamily,
        fontWeight: Regular,
        fontSize: 14,
        lineHeight: "20px"
    }),
    Footnote: _extends({}, common, {
        fontFamily: LatoFamily,
        fontWeight: Regular,
        fontSize: 12,
        lineHeight: "18px"
    })
});

exports.default = styles;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("@khanacademy/wonder-blocks-core");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _wonderBlocksCore = __webpack_require__(1);

var _styles = __webpack_require__(0);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Footnote = function (_Component) {
    _inherits(Footnote, _Component);

    function Footnote() {
        _classCallCheck(this, Footnote);

        return _possibleConstructorReturn(this, (Footnote.__proto__ || Object.getPrototypeOf(Footnote)).apply(this, arguments));
    }

    _createClass(Footnote, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                style = _props.style,
                children = _props.children,
                otherProps = _objectWithoutProperties(_props, ["style", "children"]);

            return _react2.default.createElement(
                _wonderBlocksCore.Text,
                _extends({}, otherProps, { style: [_styles2.default.Footnote, style] }),
                children
            );
        }
    }]);

    return Footnote;
}(_react.Component);

Footnote.defaultProps = {
    tag: "span"
};
exports.default = Footnote;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _wonderBlocksCore = __webpack_require__(1);

var _styles = __webpack_require__(0);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Caption = function (_Component) {
    _inherits(Caption, _Component);

    function Caption() {
        _classCallCheck(this, Caption);

        return _possibleConstructorReturn(this, (Caption.__proto__ || Object.getPrototypeOf(Caption)).apply(this, arguments));
    }

    _createClass(Caption, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                style = _props.style,
                children = _props.children,
                otherProps = _objectWithoutProperties(_props, ["style", "children"]);

            return _react2.default.createElement(
                _wonderBlocksCore.Text,
                _extends({}, otherProps, { style: [_styles2.default.Caption, style] }),
                children
            );
        }
    }]);

    return Caption;
}(_react.Component);

Caption.defaultProps = {
    tag: "span"
};
exports.default = Caption;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _wonderBlocksCore = __webpack_require__(1);

var _styles = __webpack_require__(0);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tagline = function (_Component) {
    _inherits(Tagline, _Component);

    function Tagline() {
        _classCallCheck(this, Tagline);

        return _possibleConstructorReturn(this, (Tagline.__proto__ || Object.getPrototypeOf(Tagline)).apply(this, arguments));
    }

    _createClass(Tagline, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                style = _props.style,
                children = _props.children,
                otherProps = _objectWithoutProperties(_props, ["style", "children"]);

            return _react2.default.createElement(
                _wonderBlocksCore.Text,
                _extends({}, otherProps, { style: [_styles2.default.Tagline, style] }),
                children
            );
        }
    }]);

    return Tagline;
}(_react.Component);

Tagline.defaultProps = {
    tag: "span"
};
exports.default = Tagline;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _wonderBlocksCore = __webpack_require__(1);

var _styles = __webpack_require__(0);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LabelXSmall = function (_Component) {
    _inherits(LabelXSmall, _Component);

    function LabelXSmall() {
        _classCallCheck(this, LabelXSmall);

        return _possibleConstructorReturn(this, (LabelXSmall.__proto__ || Object.getPrototypeOf(LabelXSmall)).apply(this, arguments));
    }

    _createClass(LabelXSmall, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                style = _props.style,
                children = _props.children,
                otherProps = _objectWithoutProperties(_props, ["style", "children"]);

            return _react2.default.createElement(
                _wonderBlocksCore.Text,
                _extends({}, otherProps, { style: [_styles2.default.LabelXSmall, style] }),
                children
            );
        }
    }]);

    return LabelXSmall;
}(_react.Component);

LabelXSmall.defaultProps = {
    tag: "span"
};
exports.default = LabelXSmall;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _wonderBlocksCore = __webpack_require__(1);

var _styles = __webpack_require__(0);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LabelSmall = function (_Component) {
    _inherits(LabelSmall, _Component);

    function LabelSmall() {
        _classCallCheck(this, LabelSmall);

        return _possibleConstructorReturn(this, (LabelSmall.__proto__ || Object.getPrototypeOf(LabelSmall)).apply(this, arguments));
    }

    _createClass(LabelSmall, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                style = _props.style,
                children = _props.children,
                otherProps = _objectWithoutProperties(_props, ["style", "children"]);

            return _react2.default.createElement(
                _wonderBlocksCore.Text,
                _extends({}, otherProps, { style: [_styles2.default.LabelSmall, style] }),
                children
            );
        }
    }]);

    return LabelSmall;
}(_react.Component);

LabelSmall.defaultProps = {
    tag: "span"
};
exports.default = LabelSmall;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _wonderBlocksCore = __webpack_require__(1);

var _styles = __webpack_require__(0);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LabelMedium = function (_Component) {
    _inherits(LabelMedium, _Component);

    function LabelMedium() {
        _classCallCheck(this, LabelMedium);

        return _possibleConstructorReturn(this, (LabelMedium.__proto__ || Object.getPrototypeOf(LabelMedium)).apply(this, arguments));
    }

    _createClass(LabelMedium, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                style = _props.style,
                children = _props.children,
                otherProps = _objectWithoutProperties(_props, ["style", "children"]);

            return _react2.default.createElement(
                _wonderBlocksCore.Text,
                _extends({}, otherProps, { style: [_styles2.default.LabelMedium, style] }),
                children
            );
        }
    }]);

    return LabelMedium;
}(_react.Component);

LabelMedium.defaultProps = {
    tag: "span"
};
exports.default = LabelMedium;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _wonderBlocksCore = __webpack_require__(1);

var _styles = __webpack_require__(0);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LabelLarge = function (_Component) {
    _inherits(LabelLarge, _Component);

    function LabelLarge() {
        _classCallCheck(this, LabelLarge);

        return _possibleConstructorReturn(this, (LabelLarge.__proto__ || Object.getPrototypeOf(LabelLarge)).apply(this, arguments));
    }

    _createClass(LabelLarge, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                style = _props.style,
                children = _props.children,
                otherProps = _objectWithoutProperties(_props, ["style", "children"]);

            return _react2.default.createElement(
                _wonderBlocksCore.Text,
                _extends({}, otherProps, { style: [_styles2.default.LabelLarge, style] }),
                children
            );
        }
    }]);

    return LabelLarge;
}(_react.Component);

LabelLarge.defaultProps = {
    tag: "span"
};
exports.default = LabelLarge;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _wonderBlocksCore = __webpack_require__(1);

var _styles = __webpack_require__(0);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Body = function (_Component) {
    _inherits(Body, _Component);

    function Body() {
        _classCallCheck(this, Body);

        return _possibleConstructorReturn(this, (Body.__proto__ || Object.getPrototypeOf(Body)).apply(this, arguments));
    }

    _createClass(Body, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                style = _props.style,
                children = _props.children,
                otherProps = _objectWithoutProperties(_props, ["style", "children"]);

            return _react2.default.createElement(
                _wonderBlocksCore.Text,
                _extends({}, otherProps, { style: [_styles2.default.Body, style] }),
                children
            );
        }
    }]);

    return Body;
}(_react.Component);

Body.defaultProps = {
    tag: "span"
};
exports.default = Body;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _wonderBlocksCore = __webpack_require__(1);

var _styles = __webpack_require__(0);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BodyMonospace = function (_Component) {
    _inherits(BodyMonospace, _Component);

    function BodyMonospace() {
        _classCallCheck(this, BodyMonospace);

        return _possibleConstructorReturn(this, (BodyMonospace.__proto__ || Object.getPrototypeOf(BodyMonospace)).apply(this, arguments));
    }

    _createClass(BodyMonospace, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                style = _props.style,
                children = _props.children,
                otherProps = _objectWithoutProperties(_props, ["style", "children"]);

            return _react2.default.createElement(
                _wonderBlocksCore.Text,
                _extends({}, otherProps, { style: [_styles2.default.BodyMonospace, style] }),
                children
            );
        }
    }]);

    return BodyMonospace;
}(_react.Component);

BodyMonospace.defaultProps = {
    tag: "span"
};
exports.default = BodyMonospace;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _wonderBlocksCore = __webpack_require__(1);

var _styles = __webpack_require__(0);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BodySerif = function (_Component) {
    _inherits(BodySerif, _Component);

    function BodySerif() {
        _classCallCheck(this, BodySerif);

        return _possibleConstructorReturn(this, (BodySerif.__proto__ || Object.getPrototypeOf(BodySerif)).apply(this, arguments));
    }

    _createClass(BodySerif, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                style = _props.style,
                children = _props.children,
                otherProps = _objectWithoutProperties(_props, ["style", "children"]);

            return _react2.default.createElement(
                _wonderBlocksCore.Text,
                _extends({}, otherProps, { style: [_styles2.default.BodySerif, style] }),
                children
            );
        }
    }]);

    return BodySerif;
}(_react.Component);

BodySerif.defaultProps = {
    tag: "span"
};
exports.default = BodySerif;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _wonderBlocksCore = __webpack_require__(1);

var _styles = __webpack_require__(0);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BodySerifBlock = function (_Component) {
    _inherits(BodySerifBlock, _Component);

    function BodySerifBlock() {
        _classCallCheck(this, BodySerifBlock);

        return _possibleConstructorReturn(this, (BodySerifBlock.__proto__ || Object.getPrototypeOf(BodySerifBlock)).apply(this, arguments));
    }

    _createClass(BodySerifBlock, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                style = _props.style,
                children = _props.children,
                otherProps = _objectWithoutProperties(_props, ["style", "children"]);

            return _react2.default.createElement(
                _wonderBlocksCore.Text,
                _extends({}, otherProps, { style: [_styles2.default.BodySerifBlock, style] }),
                children
            );
        }
    }]);

    return BodySerifBlock;
}(_react.Component);

BodySerifBlock.defaultProps = {
    tag: "span"
};
exports.default = BodySerifBlock;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _wonderBlocksCore = __webpack_require__(1);

var _styles = __webpack_require__(0);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HeadingXSmall = function (_Component) {
    _inherits(HeadingXSmall, _Component);

    function HeadingXSmall() {
        _classCallCheck(this, HeadingXSmall);

        return _possibleConstructorReturn(this, (HeadingXSmall.__proto__ || Object.getPrototypeOf(HeadingXSmall)).apply(this, arguments));
    }

    _createClass(HeadingXSmall, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                style = _props.style,
                children = _props.children,
                otherProps = _objectWithoutProperties(_props, ["style", "children"]);

            return _react2.default.createElement(
                _wonderBlocksCore.Text,
                _extends({}, otherProps, { style: [_styles2.default.HeadingXSmall, style] }),
                children
            );
        }
    }]);

    return HeadingXSmall;
}(_react.Component);

HeadingXSmall.defaultProps = {
    tag: "h4"
};
exports.default = HeadingXSmall;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _wonderBlocksCore = __webpack_require__(1);

var _styles = __webpack_require__(0);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HeadingSmall = function (_Component) {
    _inherits(HeadingSmall, _Component);

    function HeadingSmall() {
        _classCallCheck(this, HeadingSmall);

        return _possibleConstructorReturn(this, (HeadingSmall.__proto__ || Object.getPrototypeOf(HeadingSmall)).apply(this, arguments));
    }

    _createClass(HeadingSmall, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                style = _props.style,
                children = _props.children,
                otherProps = _objectWithoutProperties(_props, ["style", "children"]);

            return _react2.default.createElement(
                _wonderBlocksCore.Text,
                _extends({}, otherProps, { style: [_styles2.default.HeadingSmall, style] }),
                children
            );
        }
    }]);

    return HeadingSmall;
}(_react.Component);

HeadingSmall.defaultProps = {
    tag: "h4"
};
exports.default = HeadingSmall;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _wonderBlocksCore = __webpack_require__(1);

var _styles = __webpack_require__(0);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HeadingMedium = function (_Component) {
    _inherits(HeadingMedium, _Component);

    function HeadingMedium() {
        _classCallCheck(this, HeadingMedium);

        return _possibleConstructorReturn(this, (HeadingMedium.__proto__ || Object.getPrototypeOf(HeadingMedium)).apply(this, arguments));
    }

    _createClass(HeadingMedium, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                style = _props.style,
                children = _props.children,
                otherProps = _objectWithoutProperties(_props, ["style", "children"]);

            return _react2.default.createElement(
                _wonderBlocksCore.Text,
                _extends({}, otherProps, { style: [_styles2.default.HeadingMedium, style] }),
                children
            );
        }
    }]);

    return HeadingMedium;
}(_react.Component);

HeadingMedium.defaultProps = {
    tag: "h3"
};
exports.default = HeadingMedium;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _wonderBlocksCore = __webpack_require__(1);

var _styles = __webpack_require__(0);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HeadingLarge = function (_Component) {
    _inherits(HeadingLarge, _Component);

    function HeadingLarge() {
        _classCallCheck(this, HeadingLarge);

        return _possibleConstructorReturn(this, (HeadingLarge.__proto__ || Object.getPrototypeOf(HeadingLarge)).apply(this, arguments));
    }

    _createClass(HeadingLarge, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                style = _props.style,
                children = _props.children,
                otherProps = _objectWithoutProperties(_props, ["style", "children"]);

            return _react2.default.createElement(
                _wonderBlocksCore.Text,
                _extends({}, otherProps, { style: [_styles2.default.HeadingLarge, style] }),
                children
            );
        }
    }]);

    return HeadingLarge;
}(_react.Component);

HeadingLarge.defaultProps = {
    tag: "h2"
};
exports.default = HeadingLarge;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _wonderBlocksCore = __webpack_require__(1);

var _styles = __webpack_require__(0);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// TODO(alex): Once style prop validation works, if all of the style prop flow
//             types are the same then switch to using functional components.
var Title = function (_Component) {
    _inherits(Title, _Component);

    function Title() {
        _classCallCheck(this, Title);

        return _possibleConstructorReturn(this, (Title.__proto__ || Object.getPrototypeOf(Title)).apply(this, arguments));
    }

    _createClass(Title, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                style = _props.style,
                children = _props.children,
                otherProps = _objectWithoutProperties(_props, ["style", "children"]);

            return _react2.default.createElement(
                _wonderBlocksCore.Text,
                _extends({}, otherProps, { style: [_styles2.default.Title, style] }),
                children
            );
        }
    }]);

    return Title;
}(_react.Component);

Title.defaultProps = {
    tag: "h1"
};
exports.default = Title;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = require("aphrodite");

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.styles = exports.Footnote = exports.Caption = exports.Tagline = exports.LabelXSmall = exports.LabelSmall = exports.LabelMedium = exports.LabelLarge = exports.Body = exports.BodyMonospace = exports.BodySerif = exports.BodySerifBlock = exports.HeadingXSmall = exports.HeadingSmall = exports.HeadingMedium = exports.HeadingLarge = exports.Title = undefined;

var _styles = __webpack_require__(0);

var _styles2 = _interopRequireDefault(_styles);

var _title = __webpack_require__(18);

var _title2 = _interopRequireDefault(_title);

var _headingLarge = __webpack_require__(17);

var _headingLarge2 = _interopRequireDefault(_headingLarge);

var _headingMedium = __webpack_require__(16);

var _headingMedium2 = _interopRequireDefault(_headingMedium);

var _headingSmall = __webpack_require__(15);

var _headingSmall2 = _interopRequireDefault(_headingSmall);

var _headingXsmall = __webpack_require__(14);

var _headingXsmall2 = _interopRequireDefault(_headingXsmall);

var _bodySerifBlock = __webpack_require__(13);

var _bodySerifBlock2 = _interopRequireDefault(_bodySerifBlock);

var _bodySerif = __webpack_require__(12);

var _bodySerif2 = _interopRequireDefault(_bodySerif);

var _bodyMonospace = __webpack_require__(11);

var _bodyMonospace2 = _interopRequireDefault(_bodyMonospace);

var _body = __webpack_require__(10);

var _body2 = _interopRequireDefault(_body);

var _labelLarge = __webpack_require__(9);

var _labelLarge2 = _interopRequireDefault(_labelLarge);

var _labelMedium = __webpack_require__(8);

var _labelMedium2 = _interopRequireDefault(_labelMedium);

var _labelSmall = __webpack_require__(7);

var _labelSmall2 = _interopRequireDefault(_labelSmall);

var _labelXsmall = __webpack_require__(6);

var _labelXsmall2 = _interopRequireDefault(_labelXsmall);

var _tagline = __webpack_require__(5);

var _tagline2 = _interopRequireDefault(_tagline);

var _caption = __webpack_require__(4);

var _caption2 = _interopRequireDefault(_caption);

var _footnote = __webpack_require__(3);

var _footnote2 = _interopRequireDefault(_footnote);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Typography components for headings or titles.
 */


/**
 * Typography components for representing body text.
 */


/**
 * Typography components for labels.
 */


/**
 * All typography components.
 */
exports.Title = _title2.default;
exports.HeadingLarge = _headingLarge2.default;
exports.HeadingMedium = _headingMedium2.default;
exports.HeadingSmall = _headingSmall2.default;
exports.HeadingXSmall = _headingXsmall2.default;
exports.BodySerifBlock = _bodySerifBlock2.default;
exports.BodySerif = _bodySerif2.default;
exports.BodyMonospace = _bodyMonospace2.default;
exports.Body = _body2.default;
exports.LabelLarge = _labelLarge2.default;
exports.LabelMedium = _labelMedium2.default;
exports.LabelSmall = _labelSmall2.default;
exports.LabelXSmall = _labelXsmall2.default;
exports.Tagline = _tagline2.default;
exports.Caption = _caption2.default;
exports.Footnote = _footnote2.default;
exports.styles = _styles2.default;

/***/ })
/******/ ]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@khanacademy/wonder-blocks-typography/index.js
// module id = 475
// module chunks = 0